import { useTranslation } from "react-i18next";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export default function AssistantPage() {
  const { t } = useTranslation(["common", "keyword", "sidebar"]);
  return (
    <TrendzContainerCard
      title={t("common:virtual_assistant")}
    ></TrendzContainerCard>
  );
}
